module.exports = __webpack_public_path__ + "img/image_032.82dc1f58.jpg";